














import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
@Component
export default class BusinessCentralLoaderV2 extends Vue {
    @Prop() target!: string;
    contentLoaded: boolean = false;
    created() {
        console.log('url', this.target);
    }

    iframeLoad(e: any) {
        if (e.timeStamp < 10000) {
            this.contentLoaded = true;
        }
    }
}
